// extracted by mini-css-extract-plugin
export default {"Container":"Search_Container__E55hM","SearchIcon":"Search_SearchIcon__Xkrbn","Input":"Search_Input__XeI4T","ClearAnchor":"Search_ClearAnchor__9JWzL"};